import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function WhatsAppButton() {
  const [wa, setWa] = useState("5581999999999");
  useEffect(() => { api.get("/settings").then((r) => { if (r.data?.whatsapp) setWa(r.data.whatsapp); }).catch(() => {}); }, []);
  const msg = encodeURIComponent("Olá! Vim pelo site da Lara B. e gostaria de tirar uma dúvida.");
  return (
    <a
      href={`https://wa.me/${wa}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-20 md:bottom-6 right-5 z-30 w-14 h-14 rounded-full bg-[#7DBE9E] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
    >
      <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current"><path d="M20.52 3.48A11.84 11.84 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.12.55 4.19 1.6 6.01L0 24l6.17-1.62A11.95 11.95 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.21-3.48-8.52zM12 22c-1.84 0-3.65-.5-5.23-1.44l-.37-.22-3.66.96.98-3.57-.24-.37A9.95 9.95 0 1 1 22 12c0 5.52-4.48 10-10 10zm5.47-7.47c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15s-.77.97-.95 1.17c-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.88-.78-1.48-1.74-1.66-2.04-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.05 1.02-1.05 2.5s1.08 2.9 1.23 3.1c.15.2 2.13 3.25 5.17 4.56.72.31 1.28.5 1.72.63.72.23 1.37.2 1.88.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z"/></svg>
    </a>
  );
}
